import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import { ClientAccessControl } from "@careinfo/permission-required";
import { classNames } from "../../utils/classNames";
import TabPanel from "../Reusable/Tab";
import { getKey } from "../../helpers/sessionKey";

const PickupRequestList = (props: any) => {
  const { draftOrder } = props;
  const navigate = useNavigate();
  const clientType = getKey("client-type");
  const defaultColumns: any = [
    {
      header: "Waybill",
      accessorKey: "tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Driver",
      accessorKey: "driver.user.full_name",
      cell: NACell,
    },
    {
      header: "Mobile No.",
      accessorKey: "driver.user.mobile_number",
      cell: NACell,
    },
    {
      header: "Vehicle",
      accessorKey: "vehicle.license_number",
      cell: NACell,
    },

    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => (
        <p>{row?.original?.items?.total ?? 0.0}</p>
      ),
    },
  ];
  let OrderColumns: any = [
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer`}>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_tracking"]}
            >
              <p
                className={classNames(
                  row?.original?.is_duplicate ? tw`text-red-600` : tw``,
                  tw`whitespace-nowrap`
                )}
              >
                {getValue() ?? "N/A"}
              </p>
            </ClientAccessControl>
            <p className={tw`text-xs text-gray-500`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>
          </div>
        );
      },
    },
    {
      header: "Ref No.",
      accessorKey: "reference_number",
      cell: ({ getValue }: any) => {
        return (
          <ClientAccessControl
            children={<p> {getValue() || "N/A"} </p>}
            allowedPermissions={["can_view_merchant_reference"]}
          />
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_name"]}
            >
              <p className={tw`whitespace-nowrap`}>
                {row?.original?.receiver.full_name ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_number"]}
            >
              <p className={tw`whitespace-nowrap text-sm`}>
                {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_location"]}
            >
              <p className={tw`text-warp w-56 text-sm`}>
                {row?.original?.receiver.address ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
          </>
        );
      },
    },
    {
      header: "Piece",
      accessorKey: "piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <button className={tw`cursor-pointerb focus:outline-none`}>
              {getValue() ?? 0.0}
            </button>
          </>
        );
      },
    },
    // {
    //   header: "Weight",
    //   accessorKey: "weight",
    //   cell: ({ row, getValue }: any) => {
    //     return (
    //       <>
    //         <p>
    //           {getValue()}
    //           <span className="text-gray-500 text-xs">Kgs</span>{" "}
    //         </p>
    //       </>
    //     );
    //   },
    // },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => (
        <ClientAccessControl allowedPermissions={["can_view_merchant_remarks"]}>
          <div className={tw`cursor-pointer`}>
            <p>{getValue()} Remarks</p>
          </div>
        </ClientAccessControl>
      ),
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <ClientAccessControl
            allowedPermissions={["can_view_merchant_status"]}
          >
            <>
              {row?.original?.is_draft ? (
                <p
                  className={tw`uppercase px-1 text-center rounded-md`}
                  style={{ background: "#1C90E9" }}
                >
                  Draft
                </p>
              ) : (
                <p
                  className={tw`uppercase px-1 text-center rounded-md`}
                  style={{ background: row?.original?.delivery_status?.color }}
                >
                  {getValue()}
                </p>
              )}
              <p className={tw`text-xs text-primary `}>
                {row?.original?.rider?.name}
              </p>
            </>
          </ClientAccessControl>
        );
      },
    },
  ];
  const handleEditNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  return (
    <>
      {clientType === "cargo" ? (
        <DataTable
          url={`${APIS.PICKUPREQUEST}`}
          queryKey={"pickup-request"}
          handleEditNavigate={handleEditNavigate}
          columns={defaultColumns}
          addNewPagePath={"/create"}
          tableName={"pickup-requests"}
          actionMenu={
            <>
              {draftOrder?.count ? (
                <button
                  type="button"
                  className={tw`flex w-full flex-row justify-end items-center focus:outline-none `}
                  onClick={() => navigate(`/create`)}
                >
                  <span>Draft Orders &#58;{draftOrder?.count}</span>
                </button>
              ) : (
                ""
              )}
            </>
          }
        />
      ) : (
        <>
          <TabPanel
            tabTitle={["Pickup Request", "Pickup Order"]}
            tabPanels={[
              <div>
                <DataTable
                  url={`${APIS.PICKUPREQUEST}`}
                  queryKey={"pickup-request"}
                  handleEditNavigate={handleEditNavigate}
                  columns={defaultColumns}
                  addNewPagePath={"/create"}
                  tableName={"pickup-requests"}
                  actionMenu={
                    <>
                      {draftOrder?.count ? (
                        <button
                          type="button"
                          className={tw`flex w-full flex-row justify-end items-center focus:outline-none `}
                          onClick={() => navigate(`/create`)}
                        >
                          <span>Draft Orders &#58;{draftOrder?.count}</span>
                        </button>
                      ) : (
                        ""
                      )}
                    </>
                  }
                />
              </div>,
              <div className={tw`flex flex-col mb-4`}>
                <DataTable
                  url={APIS.ORDER}
                  queryKey={"orders"}
                  columns={OrderColumns}
                  tableName={"pickup-order"}
                  params={{ is_pickup_created: true }}
                />
              </div>,
            ]}
          />
        </>
      )}
    </>
  );
};

export default PickupRequestList;
